<template lang="pug">
  .option-swatch(:style="swatchStyles" :class="`option-swatch--${option.label.toLowerCase()}`")
</template>

<script>
  import { getSwatchSrc } from 'scripts/helpers/images.js';
  import { handleize } from 'scripts/filters/string.js';

  export default {
    name: 'OptionSwatch',
    props: {
      option: Object,
    },
    computed: {
      swatchSrc() {
        if (this.option.label === 'Color') return getSwatchSrc(handleize(this.option.value), '30x');
        return this.option.image;
      },
      swatchStyles() {
        return {
          'background-image': `url(${this.swatchSrc})`,
        };
      },
    },
  };
</script>

<style scoped lang="scss">
  .option-swatch {
    background-position: center;
    background-repeat: no-repeat;
  }

  .option-swatch--color {
    background-size: cover;
    height: 36px;
    width: 36px;
  }

  .option-swatch--size {
    opacity: 0.5;
    background-size: contain;
    height: 64px;
  }
</style>
